import "babel-polyfill";
import * as React from "react";
import * as ReactDom from "react-dom";
import {Provider} from "react-redux";
import {compose, createStore, applyMiddleware} from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "./redux/index";
import Saga from "./redux/saga";
import App from "./app";
import "./styling/index.scss";
import persistState from 'redux-sessionstorage';

const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(
            sagaMiddleware
        ),        
        persistState(["app", "user"])
    )
);

sagaMiddleware.run(Saga);


ReactDom.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);